import React from 'react'
import { useEffect, useState } from "react";
import TempDropDown from "./TempDropDown";
import { Chart } from 'react-chartjs-2';;
  
const CouponsComparision = ({ weeks, graphData }) => {

    
    // console.log('weeks, graphData', weeks, graphData)
    const [currentWeek, setCurrentWeek] = useState(weeks[0] ?? "");
    const [currentWeekData, setCurrentWeekData] = useState(graphData[currentWeek] ?? []);
  
    useEffect(() => {
      setCurrentWeekData(graphData[currentWeek]);
    }, [currentWeek])

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'right',
            labels: {
              usePointStyle: true,
              useBorderRadius: true,
              padding: () => {
                if (window.innerWidth < 600) return 6;
                if (window.innerWidth < 650) return 7;
                if (window.innerWidth < 700) return 8;
                if (window.innerWidth < 750) return 9;
                if (window.innerWidth < 800) return 10;
                if (window.innerWidth < 900) return 10;
                if (window.innerWidth < 1100) return 13;
                if (window.innerWidth < 1300) return 16;
                return 18;
              },
              font: {
                size: () => {
                  if (window.innerWidth < 600) return 10;
                  if (window.innerWidth < 700) return 12;
                  if (window.innerWidth < 800) return 13;
                  if (window.innerWidth < 900) return 13.5;
                  if (window.innerWidth < 1100) return 14.5;
                  if (window.innerWidth < 1300) return 16;
                  if (window.innerWidth < 1450) return 17;
                  if (window.innerWidth < 1600) return 18;
                  return 19;
                },
              },
            },
            onHover: (event, legendItem) => {
              document.getElementById("chart22").style.cursor = 'pointer';
            },
            onLeave: (event, legendItem) => {
              document.getElementById("chart22").style.cursor = 'default';
            },
          },
        },
        scales: {
          x: {
            title: {
              text: "Coupon Code",
              display: true,
              font: {
                size: 13.5,
              },
            },
            grid: {
              display: false,
            },
          },
          y: {
            title: {
              display: true,
              text: 'Number of unique shoppers',
              font: {
                size: 13.5,
              },
            },
          },
        },
      };
    
      const labels = currentWeekData?.map(item => item.couponCode);
    
      // Constructing datasets for each metric
      const data = {
        labels,
        datasets: [
          {
            label: 'Coupon Shown',
            data: currentWeekData?.map(item => item.couponShown),
            backgroundColor: 'rgba(230, 80, 140, 1)',
            hoverBackgroundColor: 'rgba(230, 80, 140, 1)',
            borderColor: 'rgba(190, 70, 160, 0.6)',
            type: 'bar',
          },
          {
            label: 'Coupon Add to Cart',
            data: currentWeekData?.map(item => item.couponAddToCart),
            backgroundColor: 'rgba(80, 180, 140, 1)',
            hoverBackgroundColor: 'rgba(80, 180, 140, 1)',
            borderColor: 'rgba(70, 160, 120, 0.6)',
            type: 'bar',
          },
          {
            label: 'Coupon Sales Done',
            data: currentWeekData?.map(item => item.couponSalesDone),
            backgroundColor: 'rgba(100, 100, 250, 1)',
            hoverBackgroundColor: 'rgba(100, 100, 250, 1)',
            borderColor: 'rgba(90, 90, 230, 0.6)',
            type: 'bar',
          }
        ]
      };
        
      return (
        <div className="graph flex flex-col col-span-2">
        <div className="graph__title">
          <h4>Coupons-wise performance</h4>
          <TempDropDown currentWeek={currentWeek} setCurrentWeek={setCurrentWeek} weeks={weeks} />
        </div>
          <Chart className="chart" id="chart22" options={options} data={data} />
        </div>
      );
}

export default CouponsComparision